import { render, staticRenderFns } from "./ActRotulo.vue?vue&type=template&id=4d85bf47&scoped=true&"
import script from "./ActRotulo.vue?vue&type=script&lang=js&"
export * from "./ActRotulo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d85bf47",
  null
  
)

export default component.exports